import gql from 'graphql-tag';
import { query } from 'services/graphql';
import { userDetailsFragment } from 'graphql/user/fragments';

export const fetchUsersWithAccessToSurfaceQuery = gql`
  query fetchUsersWithAccessToSurface($surface: String!) {
    fetchUsersWithAccessToSurface(surface: $surface) {
      nodes {
        ... on UserWithRole {
          user {
            ...userDetails
          }
          role
        }
        ... on InvitationWithRole {
          invitation {
            id
            email
          }
          role
        }
      }
      error
    }
  }
  ${userDetailsFragment}
`;

export default query(fetchUsersWithAccessToSurfaceQuery);
